import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import StepRoutes from "../../../Routes/steps_routes";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import LoadingPage from "../../../Components/layouts/loading";
import { useEffect } from "react";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { IoLogoWhatsapp } from "react-icons/io";

const ViewWhatsAppTemplateSettingData = () => {
  const [data, setData] = useState();
  let { id } = useParams();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/whatsAppTemplateSetting/getById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting Whats App Template");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <IoLogoWhatsapp style={{ color: "green" }} /> Whats App Template Setting
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header row g-2 align-items-center">
              <div className="col">
                <h2>Template Details</h2>
              </div>
              <div className="col-auto ms-auto d-print-none"></div>
            </div>
            <div className="card-body">
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Template Name
                    </label>
                    <div className="w-100 col">
                      {(data?.templateName || "N/A").toUpperCase()}
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Template Label
                    </label>
                    <div className="w-100 col">
                      {(data?.templateLabel || "N/A").toUpperCase()}
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Template Hit Condition
                    </label>
                    <div className="w-100 col">
                      {(data?.templateHitCondtion || "N/A").toUpperCase()}
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Template Active Status
                    </label>
                    <div className="w-100 col">
                      { data?.isActive? "ON" : "OFF"}
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Template Description
                    </label>
                    <div className="w-100 col">
                      {(data?.description || "N/A").toUpperCase()}
                    </div>
                  </div>
            </div>
            <div className="card-footer">
              <div className="btn-list justify-content-end">
                <SimpleButton
                  buttonText="Edit Template Details"
                  onClick={() => navigate(`/edit-whatsapp-template-setting/${id}`)}
                />
                <SimpleButton buttonText="Cancel" type="secondary" />
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ViewWhatsAppTemplateSettingData;
